module.exports = __webpack_public_path__ + "img/transfer-videos.bfc81592.svg";